export default "__VITE_ASSET__BukAXbZ5__";